import { ScreenScheduleList } from '@dms/screen'

// export { getServerSideProps } from '@dms/screen/location/list'

export default ScreenScheduleList
